// extracted by mini-css-extract-plugin
export default {"ekomiComponent":"EkomiComponent__ekomiComponent","main":"EkomiComponent__main","ratingLabel":"EkomiComponent__ratingLabel"};